<template lang="pug">
section.page-login.column.center
  .lang(@click="$root.change_lang")
    svg-icon(:name="($root.lang === 'fr') ? 'flag-en' : 'flag-fr'")
  .welcome.column.center(v-if="reset")
    h3 {{ t.password_reset }}
    template(v-if="reset === 'success'")
      div Un email de réinitialisation du mot de passe vous à été envoyé à l'addresse {{ email_reset }}
      button.primary(@click="reset = false") Retour
    template(v-else-if="reset === 'failure'")
      div Aucun compte n'existe pour {{ email_reset }}
      button.primary(@click="reset = false") Retour
    template(v-else-if="reset === 'loading'")
      div {{ t.loading }}
    form(v-else @submit.prevent)
      .input.row.between.center
        label Email
        input(type="email" v-model="email_reset")
      .row.around.center(style="width: 100%;")
        button(@click="reset = false") Retour
        button(@click="reset_password" :class="[(email_reset) ? 'primary' : 'inactive' ]") Valider
  .welcome.column.center(v-else)
    img(src="../assets/img/labellecom-title.svg")
    h3 {{ t.idea_box }}
    .input.row.between.center
      label Email
      input(type="email" v-model="email")
    .input.row.between.center
      label Password
      input(v-model="password" type="password")
    .row(v-if="status")
      div(:class="{red: ['wrong-password', 'user-not-found', 'error'].includes(status)}") {{ t[status] }}
    .forgot-password.row.center(@click="reset = true") {{ t.forgotten_password }} ?
    button(@click="login" :class="[(email && password) ? 'primary' : 'inactive' ]") Login
</template>
<script>
export default {
  data() {
    return {
      email: null,
      password: null,
      reset: false,
      email_reset: null,
      status: null,
    }
  },
  methods: {
    login() {
      this.status = 'loading'
      this.$root.login_email(this.email, this.password)
        .then(() => {
          this.status= false
          this.$router.push(this.$route.query.from || '/home')
        })
        .catch((e) => {
          if (e.code === 'auth/wrong-password') return this.status = 'wrong-password'
          if (e.code === 'auth/user-not-found') return this.status = 'user-not-found'
          this.status = 'error'
        })
    },
    reset_password() {
      this.reset = 'loading'
      firebase.auth().sendPasswordResetEmail(this.email_reset)
        .then(() => this.reset = 'success')
        .catch((e) => this.reset = 'failure')
    }
  }
}


</script>
<style>
/* .page-login {
  background: var(--gradient-background);
} */
.page-login .lang {
  position: fixed;
  bottom: 40px;
  right: 40px;

}
.page-login .lang .svg-icon {
  width: 24px;
  height: 24px;
}
.page-login .welcome {
  background: white;
  padding: 32px;
  border-radius: 4px;
  min-width: 360px;
}
.page-login .welcome img, .page-login .welcome h3 {
  margin-bottom: 16px;
}
.page-login .welcome .input {
  margin-top: 12px;
  width: 100%;
  font-size: 16px;
}
.page-login .welcome button {
  margin-top: 32px;
  min-width: 120px;
}
.page-login .welcome .input input {
  background: var(--lightgrey);
  height: 32px;
  font-size: 16px;
}
.page-login .forgot-password {
  margin-top: 8px;
  font-size: 12px;
}
.page-login .forgot-password:hover {
  text-decoration: underline;
  cursor: pointer;
}
.page-login div.red {
  color: var(--secondary);
}
.mobile:not(.laptop) .page-login {
  padding: 0;
  max-height: var(--full-height);
}
.mobile:not(.laptop) .page-login .lang {
  display: none;
}
.mobile:not(.laptop) .page-login .welcome {
  margin: 0;
  min-width: 0;
  width: 100%;
}
.mobile:not(.laptop) .page-login .welcome .input {
  flex-direction: column;
  align-items: start;
}
.mobile:not(.laptop) .page-login .welcome .input input,
.mobile:not(.laptop) .page-login .welcome button {
  width: 100%;
  padding: 8px 16px;
  height: 48px;
}
</style>
